import React, { useState } from 'react'

import { TtButton, TtCard, TtIcon } from '@23/ui-react'

import { type WidgetDTO } from '../../../../../../model/Widget'

interface EmbedPreviewProps {
  widget: WidgetDTO
  isEditable: boolean
  handleEdit: () => void
  handleDelete: () => void
}

const EmbedPreview = ({
  widget,
  isEditable,
  handleEdit,
  handleDelete,
}: EmbedPreviewProps) => {
  const [showActions, setShowActions] = useState(false)

  if (!widget.embed_html) return null

  return (
    <div
      className="personal-widget-embed-wrapper"
      onMouseEnter={() => isEditable && setShowActions(true)}
      onFocus={() => isEditable && setShowActions(true)}
      onMouseLeave={(e) => {
        const target = e.relatedTarget as Node | null
        if (!target || !e.currentTarget.contains(target)) {
          setShowActions(false)
        }
      }}
      onBlur={(e) => {
        const target = e.relatedTarget as Node | null
        if (!target || !e.currentTarget.contains(target)) {
          setShowActions(false)
        }
      }}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isEditable ? 0 : undefined}
    >
      {isEditable && showActions && (
        <div className="personal-widget-embed-actions">
          <TtButton
            color="secondary"
            variant="light"
            size="x-small"
            className="personal-widget-embed-action personal-widget-embed-action--delete"
            onClick={handleDelete}
            label="Delete"
          >
            <TtIcon library="one" name="bin" />
          </TtButton>
          <TtButton
            color="secondary"
            variant="light"
            size="x-small"
            className="personal-widget-embed-action personal-widget-embed-action--edit"
            onClick={handleEdit}
            label="Edit"
          >
            <TtIcon library="one" name="edit" />
          </TtButton>
        </div>
      )}
      <TtCard className="personal-widget-embed" hideLabel>
        <div
          className="personal-widget-embed-content"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: widget.embed_html }}
        />
      </TtCard>
    </div>
  )
}

export { EmbedPreview }
